import { ChangeDetectorRef, inject, Injectable } from "@angular/core";
import { IDetalleTema } from "../../interfaces/temas";
import { AppState } from "../../app.state";
import { select, Store } from "@ngrx/store";
import { selectUsuario } from "../../states/usuario/selector";
import { selectAllAcuerdos } from "../../states/acuerdos-mrb/selector";
import { AcuerdoMrbService } from "../../acuerdo-mrb/acuerdo-mrb.service";
import * as moment from "moment";
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";


@Injectable({
  providedIn: "root",
})
export class AcuerdosUtilsService {
  private stateUser: any = this.store.pipe(select(selectUsuario));
  private readonly stateTipoAcuerdo: any = this.store.pipe(
    select(selectAllAcuerdos)
  );

  constructor(private store: Store<AppState>, private fb: FormBuilder) {}

  getPermisoEscritura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.escritura.includes(categorizacionTema);
  };

  getPermisoLectura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.lectura.includes(categorizacionTema);
  };

  esHistorico(): boolean {
    const tipoAcuerdo = structuredClone(
      this.stateTipoAcuerdo.state().acuerdosMRB.tipoAcuerdo
    );
    return tipoAcuerdo === 3;
  }
  getEsResponsable(tema: IDetalleTema) {
    const user = this.stateUser.state().usuario;
    const esResponsable = [
      tema.respAnalista,
      tema.respCoordinador,
      tema.respSupervisor,
    ].includes(user.uid);

    return esResponsable;
  }
  esResponsableNuevoTema(tema: IDetalleTema) {
    return (
      (!this.getEsResponsable(tema) && !tema.nuevoTema) || this.esHistorico()
    );
  }
  getDefaultTipoTema(tipoTema: number, catTipoTema: any[]): number | null {
    if (catTipoTema.length > 0) {
      if (tipoTema && catTipoTema.some((item) => item.id === tipoTema)) {
        return tipoTema;
      } else {
        return catTipoTema[0].id;
      }
    } else {
      return null;
    }
  }

  getDefaultCategorizacion(
    idCat: string,
    catCategorizacion: any[],
    tema?: IDetalleTema
  ): string | null {
    //si el tema es confidencial
    if (tema && !this.showTema(tema)) {
      return tema.categorizacion;
    }

    //si no cuenta con permisos
    const permisos = this.getCategorizacioCombo(catCategorizacion);
    if (permisos.length == 0) {
      return tema?.categorizacion ?? "";
    }

    //si el tema es corporativo
    const corporativo = permisos.find((cat) => cat.descripcion === "C");
    if (!idCat && corporativo) {
      return corporativo.id;
    }
    //si el tema es no es corporativo
    if (idCat && permisos.some((item) => item.id === idCat)) {
      return idCat;
    } else {
      return idCat;
    }
  }
  puedeEditar(tema: IDetalleTema): boolean {
    const nuevoTema = tema.nuevoTema;
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    return (nuevoTema || (soloEscritura && soloLecura)) && !this.esHistorico();
  }

  editarObservacion(tema: IDetalleTema): boolean {
    const nuevoTema = tema.nuevoTema;
    const edoTema = tema.edoTema == 3;
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    return edoTema || !(nuevoTema || (soloEscritura && soloLecura));
  }

  disableEntradas(tema: IDetalleTema, entadas?: any[]): boolean {
    const entradas = this.stateUser.state().entradas.entradas;
    if (entradas.length == 0 || (entadas && entadas.length == 0)) {
      return true;
    }
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    if (tema.nuevoTema) {
      return false;
    }
    if (!tema.nuevoTema && !soloEscritura) {
      return true;
    }
    return false;
  }
  showTema = (tema: IDetalleTema): boolean => {
    const nuevoTema = tema.nuevoTema;
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    return nuevoTema || soloLecura || (soloLecura && soloEscritura);
  };

  showConfidencial(tema: IDetalleTema): boolean {
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    const nuevoTema = tema.nuevoTema ?? false;
    return !soloLecura && soloEscritura && !nuevoTema;
  }

  getNumeroEntregables(tema: IDetalleTema): number {
    let numEntregables = 0;

    if (tema.entradas.length == 0) {
      return 0;
    }
    tema.entradas.forEach((entrada) => {
      if (entrada.entregables && entrada.entregables.length > 0) {
        numEntregables += entrada.entregables.length; // Accumulate the total count
      }
    });

    return numEntregables;
  }

  formatToISOWithAdjustedTime(dateString: string): string {
    const utcDate = moment.utc(dateString);
    const adjustedDate = utcDate.hour(6).minute(0).second(0).millisecond(0);
    return adjustedDate.toISOString();
  }

  getCategorizacioCombo(catCategorizacion: any[]): any[] {
    const user = this.stateUser.state().usuario.temas;
    return catCategorizacion.filter((item: any) => {
      const tema = user[item.id];
      return tema && (tema.permiso === 2 || tema.permiso === 3);
    });
  }

  getAllCategorizacion(catCategorizacion: any[]): any[] {
    const user = this.stateUser.state().usuario.temas;
    return catCategorizacion.filter((item: any) => {
      const tema = user[item.id];
      return tema;
    });
  }

  enabledConfidencial(catCategorizacion: any[]): boolean {
    const opciones = this.getCategorizacioCombo(catCategorizacion);

    const habilitarConfidencial = opciones.filter((item: any) => {
      return (
        item.descripcionCompleta &&
        (item.descripcionCompleta.toLowerCase().includes("confidencial") ||
          item.descripcionCompleta.toLowerCase().includes("personal"))
      );
    });

    return habilitarConfidencial.length > 0;
  }

  requiredWhenTouchedValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return control.dirty && !control.value
        ? { requiredWhenTouched: true }
        : null;
    };
  }

  createFormGroupTemas(
    temas: IDetalleTema[],
    catCategorizacion: any[],
    catTipoTema: any[]
  ): FormGroup[] {
    const user = this.stateUser.state().usuario;
    if (temas.length > 0) {
      return temas.map((tema) => {
        return this.fb.group({
          idTema: [tema.id],
          nombreTema: [
            {
              value: tema.nombreTema,
              disabled:
                (!this.getPermisoEscritura(tema.categorizacion) &&
                  !tema.nuevoTema) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          descripcionTema_html: [
            {
              value: tema.descripcionTema_html,
              disabled:
                (!this.getPermisoEscritura(tema.categorizacion) &&
                  !tema.nuevoTema) ||
                this.esHistorico(),
            },
            [Validators.required],
          ],
          accion: [
            {
              value: "",
              disabled: this.disableAccion(tema),
            },
          ],
          respAnalista: [
            {
              value: tema.respAnalista,
              disabled: this.esResHisPuedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          respCoordinador: [
            {
              value: tema.respCoordinador,
              disabled: this.esResHisPuedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          respSupervisor: [
            {
              value: tema.respSupervisor,
              disabled: this.esResHisPuedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          esAprobado: [
            {
              value: tema.esAprobado,
              disabled: this.esResHisPuedeEditar(tema),
            },
            [Validators.required],
          ],
          tipoTema: [
            {
              value: this.getDefaultTipoTema(tema.tipoTema, catTipoTema),
              disabled: this.esResHisPuedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],

          esConfidencial: [
            {
              value: tema.esConfidencial,
              disabled:
                this.esResHisPuedeEditar(tema) ||
                !this.enabledConfidencial(catCategorizacion),
            },
            [Validators.required],
          ],
          id_categoria: [
            {
              value: tema.nuevoTema ? null : tema.id_categoria,
              disabled: this.esResHisPuedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          categorizacion: [
            {
              value: this.getDefaultCategorizacion(
                tema.categorizacion,
                catCategorizacion,
                tema
              ),
              disabled: this.esResHisPuedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          esImpreso: [
            {
              value: tema.esImpreso,
              disabled: this.esResHisPuedeEditar(tema),
            },
            [Validators.required],
          ],
          entradas: [tema.entradas],
          indiceTema: [tema.indiceTema],
          expanded: [tema.expanded],

          entradaSelected: [
            {
              value: "",
              disabled: this.esHistorico() || this.disableEntradas(tema),
            },
          ],
          indicacion: [
            {
              value: "",
              disabled: this.editarObservacion(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          indicacionesAB: [tema.indicacionesAB, [Validators.required]],
          nuevoTema: [tema.nuevoTema],
          fechaAcuerdo: [tema.fechaAcuerdo],
          edoTema: [tema.edoTema],
          id: [tema.id],
          //parra nuevos temas obtener noommbre para
          nombreAnalista: [""],
          nombreSupervisor: [""],
          nombreCoordinador: [""],
          id_categorizacion: [
            this.getDefaultCategorizacion(
              tema.categorizacion,
              catCategorizacion,
              tema
            ),
          ],
          nombreUsuario: [user.nombre],
          //si no tiene persmisos desabilitar
          showDetalleTema: [this.showTema(tema)],
          showConfidencial: [this.showConfidencial(tema)],
          numEntregables: [this.getNumeroEntregables(tema)],
          editorInstanceId: ["editorInstanceId-" + tema.indiceTema],
        });
      });
    }
    return [];
  }

  esResHisPuedeEditar(tema: IDetalleTema) {
    return (
      (!(this.puedeEditar(tema) && this.getEsResponsable(tema)) &&
        !tema.nuevoTema) ||
      this.esHistorico()
    );
  }

  disableAccion(tema: IDetalleTema): boolean {
    const editarHistorico = this.puedeEditar(tema) && this.getEsResponsable(tema);
    if (this.esHistorico()) {
      return  !this.getEsResponsable(tema);
    }
    return !editarHistorico; 
  }
}
